export default "__VITE_ASSET__DnAtGzJK__"